'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Modal = require('@cimpress/react-components/lib/Modal');
var _Modal2 = _interopRequireDefault(_Modal);
var _Spinner = require('@cimpress/react-components/lib/shapes/Spinner');
var _Spinner2 = _interopRequireDefault(_Spinner);
var _ManyTenantsSelect = require('./ManyTenantsSelect');
var _ManyTenantsSelect2 = _interopRequireDefault(_ManyTenantsSelect);
var _SimpleSelect = require('./SimpleSelect');
var _SimpleSelect2 = _interopRequireDefault(_SimpleSelect);
require('./SelectorModal.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Maximum number of tenants user has access to that will still show the simplified selector
 */
var MAX_TENANTS_SIMPLE_SELECTOR = 6;
var SelectorDelegator = function (_React$Component) {
  _inherits(SelectorDelegator, _React$Component);
  function SelectorDelegator() {
    _classCallCheck(this, SelectorDelegator);
    return _possibleConstructorReturn(this, (SelectorDelegator.__proto__ || Object.getPrototypeOf(SelectorDelegator)).apply(this, arguments));
  }
  _createClass(SelectorDelegator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        authToken = _props.authToken,
        onChange = _props.onChange,
        resourceType = _props.resourceType,
        selectedFulfiller = _props.selectedFulfiller,
        selectedMerchant = _props.selectedMerchant,
        merchants = _props.merchants,
        fulfillers = _props.fulfillers;
      var tenantCountOverTreshold = merchants.length + fulfillers.length > MAX_TENANTS_SIMPLE_SELECTOR;
      var selectorComponent = tenantCountOverTreshold ? _react2.default.createElement(_ManyTenantsSelect2.default, {
        authToken: authToken,
        selectedMerchant: selectedMerchant,
        resourceType: resourceType,
        onChange: onChange,
        merchants: merchants,
        fulfillers: fulfillers
      }) : _react2.default.createElement(_SimpleSelect2.default, {
        selectedMerchant: selectedMerchant,
        selectedFulfiller: selectedFulfiller,
        resourceType: resourceType,
        onChange: onChange,
        merchants: merchants,
        fulfillers: fulfillers
      });
      return selectorComponent;
    }
  }]);
  return SelectorDelegator;
}(_react2.default.Component);
SelectorDelegator.propTypes = {
  authToken: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  selectedFulfiller: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  selectedMerchant: _propTypes2.default.string,
  resourceType: _propTypes2.default.string,
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    displayName: _propTypes2.default.string.isRequired,
    merchantId: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    fulfillerId: _propTypes2.default.string.isRequired,
    internalFulfillerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    archived: _propTypes2.default.bool
  })).isRequired
};
var ModalFooter = function ModalFooter(_ref) {
  var onSave = _ref.onSave,
    onClose = _ref.onClose,
    mustSelectTenant = _ref.mustSelectTenant,
    canSave = _ref.canSave;
  return _react2.default.createElement('div', {
    className: 'pull-right'
  }, _react2.default.createElement('button', {
    className: 'btn btn-default',
    disabled: mustSelectTenant,
    onClick: onClose
  }, 'Cancel'), _react2.default.createElement('button', {
    className: 'btn btn-primary',
    disabled: !canSave,
    onClick: onSave
  }, 'Save'));
};
ModalFooter.propTypes = {
  onSave: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  mustSelectTenant: _propTypes2.default.bool.isRequired,
  canSave: _propTypes2.default.bool.isRequired
};
var SelectorModal = function SelectorModal(_ref2) {
  var mustSelectTenant = _ref2.mustSelectTenant,
    selectedTenant = _ref2.selectedTenant,
    show = _ref2.show,
    loading = _ref2.loading,
    onClose = _ref2.onClose,
    title = _ref2.title,
    helpText = _ref2.helpText,
    props = _objectWithoutProperties(_ref2, ['mustSelectTenant', 'selectedTenant', 'show', 'loading', 'onClose', 'title', 'helpText']);
  return _react2.default.createElement(_Modal2.default, {
    className: 'modal-overflow',
    show: show || mustSelectTenant,
    title: title,
    onRequestHide: onClose,
    closeButton: !mustSelectTenant,
    footer: _react2.default.createElement(ModalFooter, _extends({
      mustSelectTenant: mustSelectTenant,
      onClose: onClose,
      loading: loading
    }, props))
  }, helpText && _react2.default.createElement('p', {
    style: {
      marginBottom: '40px'
    }
  }, helpText), loading ? _react2.default.createElement(_Spinner2.default, {
    className: 'text-center'
  }) : _react2.default.createElement(SelectorDelegator, _extends({
    selectedTenant: selectedTenant
  }, props)));
};
SelectorModal.propTypes = {
  authToken: _propTypes2.default.string.isRequired,
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    displayName: _propTypes2.default.string.isRequired,
    merchantId: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    fulfillerId: _propTypes2.default.string.isRequired,
    internalFulfillerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    archived: _propTypes2.default.bool
  })).isRequired,
  resourceType: _propTypes2.default.string,
  mustSelectTenant: _propTypes2.default.bool.isRequired,
  selectedMerchant: _propTypes2.default.string,
  selectedFulfiller: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  show: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string.isRequired,
  helpText: _propTypes2.default.string,
  onSave: _propTypes2.default.func.isRequired,
  canSave: _propTypes2.default.bool.isRequired
};
exports.default = SelectorModal;